/**
 * A screen that failed to open (finding C8), inside the shell: never React Router's default
 * "Unexpected Application Error!" with developer text. A screen's chunk that could not load
 * (the first session offline before the service worker had the page, or an old tab after a
 * deploy) says the screen is not on this device yet and offers Muat ulang; anything else says
 * the screen could not be shown, offers the same, and is reported (../pelaporan). The title
 * takes the focus, as a page move gives it.
 */
import { uiStrings } from '@satu/shared'
import { useEffect, useRef } from 'react'
import { useRouteError } from 'react-router'
import { PigmentTick } from '@/components/primitives/PigmentTick'
import { Button } from '@/components/ui/button'
import { laporkanGalat } from '../pelaporan'

const teks = uiStrings.halamanGagal

/** The browsers' words for a dynamic import that failed: Chromium, Firefox, Safari, Vite. */
const GALAT_MODUL = [
  /dynamically imported module/i,
  /importing a module script failed/i,
  /error loading dynamically imported module/i,
  /unable to preload css/i,
]

/** A screen's chunk could not be fetched. */
export function galatModul(galat: unknown): boolean {
  const pesan = galat instanceof Error ? galat.message : typeof galat === 'string' ? galat : ''
  return GALAT_MODUL.some((pola) => pola.test(pesan))
}

export function HalamanGagal() {
  const galat = useRouteError()
  const modul = galatModul(galat)
  const judulRef = useRef<HTMLHeadingElement>(null)
  useEffect(() => {
    judulRef.current?.focus()
    if (!modul) laporkanGalat(galat)
  }, [galat, modul])
  return (
    <article className="flex flex-col items-start gap-6 py-6">
      <h1
        ref={judulRef}
        tabIndex={-1}
        className="flex items-baseline gap-1 font-display text-title outline-none"
      >
        <PigmentTick />
        {modul ? teks.judulBelumTersimpan : teks.judul}
      </h1>
      <p className="measure font-prose text-prose text-muted">
        {modul ? teks.kalimatBelumTersimpan : teks.kalimat}
      </p>
      <Button type="button" variant="outline" onClick={() => window.location.reload()}>
        {teks.muatUlang}
      </Button>
    </article>
  )
}
